import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from "@angular/core";
import { stringify } from "@angular/core/src/util";
import { NgForm, NgModel } from "@angular/forms";
import { element } from "protractor";
import {Statuses} from "../enums/Statuses";


@Component({
  selector: 'app-parallel-sendback-grid-edit',
  templateUrl: './parallel-sendback-grid-edit.html',
  styleUrls: ['./parallel-sendback-grid-edit.css']
})
export class ParallelSendbackGridEdit implements OnInit {
  @Input() Request:any;
  @Input() IsAcrRequest: boolean;
  @Output() LockSubmitButtonEvent = new EventEmitter<boolean>();
  @Output() SaveApplicantReplytoOPSEvent = new EventEmitter<string>();
  @Output() SaveApplicantReplytoAWEvent = new EventEmitter<string>();
  @Output() SaveIsAWSendbackAppliedEvent = new EventEmitter<boolean>();
  @Output() SaveIsOPSSendbackAppliedEvent = new EventEmitter<boolean>();


  @ViewChild("ParallelSendBackForm") formModel: NgForm;
  @ViewChild("IsAWSendbackApplied") IsAWSendbackAppliedChceckBox: ElementRef;
  @ViewChild("IsOPSSendbackApplied") IsOPSSendbackAppliedChceckBox: ElementRef;



  OPSSendBackMode: boolean;
  AWSendBackMode: boolean;
  private ApplicantreplytoOPS: string = "";
  private ApplicantreplytoAW: string = "";
  private IsAWSendbackApplied: boolean = false;
  private IsOPSSendbackApplied: boolean = false;
  private isApplied:boolean = false;


  LockSubmitButton(_isApplied: boolean)
  {
    this.LockSubmitButtonEvent.emit(_isApplied);
  }

  SaveIsAWSendbackApplied(_isAWSendbackApplied)
  {

    this.IsAWSendbackApplied = _isAWSendbackApplied;
    this.SwitchIsApplied();
    this.SaveIsAWSendbackAppliedEvent.emit(this.IsAWSendbackApplied);

  }
  SaveIsOPSSendbackApplied(_isOPSSendbackApplied)
  {
    this.IsOPSSendbackApplied = _isOPSSendbackApplied;
    this.SwitchIsApplied();
    this.SaveIsOPSSendbackAppliedEvent.emit(this.IsOPSSendbackApplied);

  }
  SaveApplicantReplytoOPS(_applicantreplytoOPS)
  {
      this.ApplicantreplytoOPS = _applicantreplytoOPS
      this.SwitchIsApplied();
      this.SaveApplicantReplytoOPSEvent.emit(this.ApplicantreplytoOPS);

  }
  SaveApplicantReplytoAW(_applicantreplytoAW: string)
  {
    this.ApplicantreplytoAW = _applicantreplytoAW
    this.SwitchIsApplied();
    this.SaveApplicantReplytoAWEvent.emit(this.ApplicantreplytoAW);
  }
  constructor() {


  }
    private isStatusIsPendingOnApplicantModifications() {
        return  (this.Request.Status.Id =="c2d846e0-0cb2-e911-a9ac-000d3a258246"
            ||
            this.Request.Status.Id.toLowerCase() === Statuses.PendingOnApplicantModifications.toLowerCase())
    }
  ngOnInit() {
    debugger;
    if(this.isStatusIsPendingOnApplicantModifications() && this.Request.IsSendBackBySubProcess == true)
    {
      if(this.Request.ApplicantReplytoOPS != "" && this.Request.ApplicantReplytoOPS != undefined)
        this.ApplicantreplytoOPS = this.Request.ApplicantReplytoOPS;
      if(this.Request.ApplicantReplytoAW !="" && this.Request.ApplicantReplytoAW != undefined)
      {
        this.ApplicantreplytoAW = this.Request.ApplicantReplytoAW;
      }
      if(this.Request.IsAWSendbackApplied == true)
      {
        this.IsAWSendbackApplied = true;
      }
      if(this.Request.IsOPSSendbackApplied == true)
      {
        this.IsOPSSendbackApplied = true;
      }

      console.log(this.Request);
      console.log(this.Request.AWSendBackToApplicantReasons);
      if (this.IsAcrRequest && (!this.Request.OPSDecision && !this.Request.AWDecision)) {
        this.Request.AWDecision = {
          Value: 4
        };
      }
      this.SwitchSendBackMode(this.Request);
      this.SwitchIsApplied();
    }
  }

  //helper Methods
  SwitchSendBackMode(Request: any)
    {
      if(Request.OPSDecision && Request.OPSDecision.Value == 4)//Send Back
      {
        this.OPSSendBackMode =true;
      }

      if(Request.AWDecision && Request.AWDecision.Value == 4)//Send Back
      {
        this.AWSendBackMode =true;
      }
    }

    SwitchIsApplied()
    {
      debugger;
      this.isApplied = false;

      if(this.Request.OPSDecision && this.Request.OPSDecision.Value == 4
          && (!this.Request.AWDecision || this.Request.AWDecision.Value !== 4)
          && this.ApplicantreplytoOPS !== "" && this.IsOPSSendbackApplied == true)//send Back by OPS only
      {
        console.log(this.ApplicantreplytoOPS)
        this.isApplied = true
       }

      if((!this.Request.OPSDecision || this.Request.OPSDecision.Value !== 4)
          && this.Request.AWDecision && this.Request.AWDecision.Value == 4
          && this.ApplicantreplytoAW !== "" && this.IsAWSendbackApplied == true)//send Back by AW only
      {
        this.isApplied = true
      }

      if(this.Request.OPSDecision &&
          this.Request.OPSDecision.Value == 4 &&
          this.Request.AWDecision &&
          this.Request.AWDecision.Value == 4)//send Back by both
      {
        if(this.IsOPSSendbackApplied == true && this.IsAWSendbackApplied == true )
        {

          if( this.ApplicantreplytoOPS != "" && this.ApplicantreplytoAW != "" )
          {


            this.isApplied = true;
          }
        }
      }
      this.LockSubmitButton(this.isApplied);

      }

      private isSendBackByOpsOnly() {

      }


      // CheckOnAWIsApplied()
      // {

      //    this.IsAWSendbackAppliedChceckBox.nativeElement.checked =true

      // }
      // CheckOnOPSIsApplied()
      // {

      //    console.log(this.IsOPSSendbackAppliedChceckBox.nativeElement.isch)

      // }


}

